export default {
      id: "skype-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite.svg#skype-usage",
      toString: function () {
        return this.url;
      }
    }